<div class="row">
    <div class="col-sm-12">
        <core-card [actions]="['collapse']">
            <h4 class="card-title">{{'Project' | translate}}</h4>
            <div class="card-body">
                <form class="form">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="search">{{'Search' | translate}}</label>
                                <input type="search" class="form-control form-control-sm" id="search" name="search"
                                    placeholder="{{'Search' | translate}}"
                                    [(ngModel)]="getStartProjectDetailsInput.searchText" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="form-label" for="projectStatus">{{'Status' | translate}}</label>
                                <select class="form-control form-control-sm" id="projectStatus" name="projectStatus"
                                    [(ngModel)]="getStartProjectDetailsInput.projectStatus">
                                    <option [ngValue]="null">{{'PleaseSelectAnyItem' | translate}}
                                    </option>
                                    <option *ngFor="let enumItem of projectStatus | enumKey" [ngValue]="enumItem.key">
                                        {{enumItem.value | translate}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4" *ngIf="token === 'dashboardToken'">
                            <div class="form-group">
                                <label class="form-label" for="customerId">{{'Customer' | translate}}</label>
                                <ng-select [virtualScroll]="true" id="customerId" name="customerId"
                                    class="ng-select-size-sm" [items]="customerListForProject"
                                    [(ngModel)]="getStartProjectDetailsInput.customerId" bindLabel="name" bindValue="id"
                                    (change)="getProjectsWithCustomerId()">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-4" *ngIf="token === 'dashboardToken'">
                            <div class="form-group">
                                <label class="form-label" for="projectId">{{'Project' | translate}}</label>
                                <ng-select [virtualScroll]="true" id="projectId" name="projectId"
                                    class="ng-select-size-sm" [items]="projectResultList"
                                    [(ngModel)]="getStartProjectDetailsInput.projectId" bindLabel="name" bindValue="id">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-4" *ngIf="token === 'dashboardToken'">
                            <label for="task-assigned" class="form-label d-block">{{'Employee'|
                                translate}}</label>
                            <ng-select [virtualScroll]="true" [items]="employeeDropdown" name="selectAssignee"
                                [(ngModel)]="getStartProjectDetailsInput.assignedEmployeeId" bindLabel="fullName"
                                bindValue="id" class="ng-select-size-sm">
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="media align-items-center">
                                        <img class="d-block rounded-circle mr-50"
                                            *ngIf="item.personalPictureFileName !== ''"
                                            src="{{utility.serviceAddress}}images/employee/{{item.personalPictureFileName}}"
                                            height="26" width="26" [alt]="item.fullName" />
                                        <img class="d-block rounded-circle mr-50"
                                            *ngIf="item.personalPictureFileName === ''" src="assets/images/avatar.png"
                                            height="26" width="26" [alt]="item.fullName" />
                                        <div class="media-body">
                                            <p class="mb-0">{{ item.fullName }}</p>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="col-12">
                            <button type="submit" rippleeffect=""
                                class="btn btn-primary mr-1 waves-effect waves-float waves-light"
                                (click)="loadData()">{{'Search' | translate}}</button>
                            <button type="submit" rippleeffect=""
                                class="btn btn-warning mr-1 waves-effect waves-float waves-light"
                                (click)="downloadExcel()">{{'Excel' | translate}}</button>
                            <button type="button" class="btn btn-outline-success" (click)="modalOpenVC(modalProject)"
                                rippleEffect>
                                {{'Add' | translate}}
                            </button>
                        </div>
                    </div>
                </form>
                <div class="table-responsive">
                    <table class="table table-sm table-hover">
                        <thead>
                            <tr>
                                <ng-container *ngFor="let item of tableHeaders">
                                    <th class="text-center" (click)="onSortChange(item.key)">{{item.title | translate}}
                                        <i *ngIf="item.isSortable === true && item.key === getStartProjectDetailsInput.sortType"
                                            class="feather"
                                            [ngClass]="{'icon-chevron-up' : (getStartProjectDetailsInput.sortOrder === sortOrder.Ascending),
                                    'icon-chevron-down' : (getStartProjectDetailsInput.sortOrder === sortOrder.Descending)}"></i>
                                    </th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of startProjectDetailListResult.data">
                                <td class="text-center">{{item.id}}</td>
                                <td class="text-center">{{item.assignedEmployeeFullName}}</td>
                                <td class="text-center">{{item.title}}</td>
                                <td class="text-center">{{projectStatus[item.projectStatus] | translate}}</td>
                                <td class="text-center">{{item.customerName}}</td>
                                <td class="text-center">{{item.projectName}}</td>
                                <td class="text-center">
                                    <button type="button" tooltipClass="fadeInAnimation" placement="top"
                                        ngbTooltip="{{'Detail' | translate}}" (click)="openModal(modalVC,item)"><i
                                            data-feather="box"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <app-pagination [disabled]="isBusy"
                    [paginationInformation]="startProjectDetailListResult.paginationInformation"
                    (pageChange)="onPageChange($event)">
                </app-pagination>
            </div>
        </core-card>
    </div>
</div>

<ng-template #modalVC let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">DUZENLEME</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <form class="form">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="form-label" for="projectStatus">{{'Status' | translate}}</label>
                        <select (change)="updateProject()" class="form-control form-control-sm" id="projectStatus"
                            name="projectStatus" [(ngModel)]="newStatusId">
                            <option [ngValue]="null">{{'PleaseSelectAnyItem' | translate}}
                            </option>
                            <option *ngFor="let enumItem of projectStatus | enumKey" [ngValue]="enumItem.key">
                                {{enumItem.value | translate}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="task-assigned" class="form-label d-block">{{'Employee'| translate}}</label>
                        <ng-select (change)="updateProject()" [virtualScroll]="true" [items]="employeeDropdown"
                            name="selectAssignee" [(ngModel)]="newAssignedEmployeeId" bindLabel="fullName"
                            bindValue="id" class="ng-select-size-sm">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="media align-items-center">
                                    <img class="d-block rounded-circle mr-50"
                                        *ngIf="item.personalPictureFileName !== ''"
                                        src="{{utility.serviceAddress}}images/employee/{{item.personalPictureFileName}}"
                                        height="26" width="26" [alt]="item.fullName" />
                                    <img class="d-block rounded-circle mr-50"
                                        *ngIf="item.personalPictureFileName === ''" src="assets/images/avatar.png"
                                        height="26" width="26" [alt]="item.fullName" />
                                    <div class="media-body">
                                        <p class="mb-0">{{ item.fullName }}</p>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #modalProject let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">Yeni Proje</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <form class="form">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="form-label" for="customerId">{{'Customer' | translate}}</label>
                        <ng-select [virtualScroll]="true" id="customerId" name="customerId" class="ng-select-size-sm"
                            [items]="customerList" [(ngModel)]="getStartProjectDetailsInput.customerId"
                            bindLabel="name" bindValue="id" (change)="getProjectsWithCustomerId()">
                        </ng-select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="projectDropdown">{{'Project' | translate}}</label>
                        <ng-select (change)="deneme()" [virtualScroll]="true" id="projectDropdown" name="projectDropdown"
                            [items]="projectResultList" class="ng-select-size-sm" [(ngModel)]="newProjectId"
                            bindLabel="name" bindValue="id">
                        </ng-select>
                    </div>
                </div>
                 <div class="col-md-12">
                    <div class="form-group">
                        <label for="projectDropdown">{{'Employee' | translate}}</label>
                        <ng-select [virtualScroll]="true" [items]="employeeDropdown" name="selectAssignee"
                        [(ngModel)]="assignedEmployeeId" bindLabel="fullName"
                        bindValue="id" class="ng-select-size-sm">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="media align-items-center">
                                <img class="d-block rounded-circle mr-50"
                                    *ngIf="item.personalPictureFileName !== ''"
                                    src="{{utility.serviceAddress}}images/employee/{{item.personalPictureFileName}}"
                                    height="26" width="26" [alt]="item.fullName" />
                                <img class="d-block rounded-circle mr-50"
                                    *ngIf="item.personalPictureFileName === ''" src="assets/images/avatar.png"
                                    height="26" width="26" [alt]="item.fullName" />
                                <div class="media-body">
                                    <p class="mb-0">{{ item.fullName }}</p>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                    </div>
                </div>
                <div class="col-12">
                    <button type="submit" rippleeffect="" [disabled]="isBusy === true"
                        class="btn mr-1 waves-effect waves-float waves-light btn-success"
                        (click)="submit()">Ekle</button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<app-alert [result]="result"></app-alert>